import { property as r } from "./index-Ba2D8NOp.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function e(t) {
  return r({ ...t, state: !0, attribute: !1 });
}
export {
  e as state
};
